import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { ParametroService } from 'src/app/service/apoio/parametro.service';
import { LoginService } from 'src/app/service/seguranca/login.service';
import { NotificacaoService } from 'src/app/service/shared/notificacao.service';
import { StorageService } from 'src/app/service/shared/storage.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
})
export class LoginComponent implements OnInit {
  public form!: FormGroup;
  private anoAtual!: string;

  constructor(
    private router: Router,
    private storage: StorageService,
    private seguranca: LoginService,
    private notificacao: NotificacaoService,
    private parametro: ParametroService,
    private login: LoginService
  ) { }

  ngOnInit(): void {
    this.storage.clean();
    this.initForm();
  }

  public fazerLogin() {
    if (this.form.valid) {
      this.seguranca.login(this.form.value).subscribe({
        next: (res: any) => {
          if (res.status) {
            this.storage.saveUserSession(res.usuario, res.token, res.permissoes);
            this.parametro.getParam().subscribe((res) => {
              this.storage.saveParameterSession(res.lista_preco, res.lista_preco_publico, res.inicio_venda, res.fim_venda);
              this.router.navigate(['/home']).then(() => {
                window.location.reload();
              });
            }
            )
          } else {
            this.notificacao.show(res.mensagem, 'OK', 'error');
          }
        },
        error: (error) => {
          this.notificacao.show(error.message, 'OK', 'error');
        }
      })
    }
  }

  private initForm() {
    this.form = new FormGroup({
      email: new FormControl('', [Validators.required, Validators.email]),
      senha: new FormControl('', [Validators.required]),
    });
  }

  public isInvalid(ctrlName: string): boolean | undefined {
    return this.form.get(ctrlName)?.invalid;
  }

  public errorMessage(ctrlName: string) {
    const field = this.form.get(ctrlName);

    if (field?.hasError('required')) {
      if (ctrlName == 'email') {
        return 'Digite seu e-mail';
      } else if (ctrlName == 'senha') {
        return 'Digite a senha';
      }
    }

    if (field?.hasError('email')) {
      return 'Digite um e-mail válido';
    }

    return '';
  }
}
